<template>

    <div id="jobs">
        <p>Sort by: Relevance Date</p>

        <div class="flex mt-6">
            <div class="w-1/2 max-h-700 px-6 overflow-y-auto">
                <div v-for="job in jobs" :key="job.id">
                    <div class="cursor-pointer" @click="selectJob(job.id)">
                        <jobscard :job='job'/>
                    </div>
                </div>
            </div>
            <div class="w-3/4 py-8 px-8">
                <div v-for="job in jobs" :key="job.id">
                    <jobsingle v-if="activeJob == job.id" :job='job'/>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import axios from 'axios';
    export default{
        
        data () {
        return {
            activeJob : null,
            jobs: [],
        }
    },
    created  ()  {
        this.fetchJobs();
    },
    methods : {
        selectJob( jobId ){
            this.activeJob = jobId;
        },
        fetchJobs(){

            let bookMarkedJobs = JSON.parse(localStorage.getItem('bookMarkedJobs'));
            
            axios.post('/api/bookmarked-jobs', {
                ids: bookMarkedJobs
            })
            .then((response) => {
                console.log(response);
                this.jobs = response.data;
                if (this.jobs.length > 0) {
                    this.selectJob( this.jobs[0].id );
                }
            })
            .catch((error) => {
                console.log(error);
            });

        }
    }
    }
    
</script>
